// Helper to set the location content

export default function buildLocationContent(loc) {

    return {
        name: loc.name,
        images: loc.images || [],
        color: loc.category.color,
        locationInfos: loc.location_infos,
        latitude: loc.latitude,
        longitude: loc.longitude
    };
}